import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { setShippingAddresses } from "../helpers/helperFunctions";
import { IAddressData } from "../types/GlobalInterfaces";
import { toast } from "react-toastify";
import { CartItemToast } from "src/lib/constans";

interface IProduct {
  _id: string;
  quantity: number;
  itemType?: "product" | "package";
}

interface CartState {
  pharmacyProducts: IProduct[];
  diagnosticProducts: IProduct[];
  address: IAddressData | string | null;
}

const initialState: CartState = {
  pharmacyProducts: [],
  diagnosticProducts: [],
  address: null,
};

const cartSlice = createSlice({
  name: "CART_SLICE",
  initialState,
  reducers: {
    setCurrentAddress: (
      state,
      { payload }: PayloadAction<IAddressData | string | null>
    ) => {
      if (typeof payload === "string") {
        setShippingAddresses(payload); // Save to local storage
        state.address = payload;
      } else {
        state.address = payload;
      }
    },
    addItem: (
      state,
      action: PayloadAction<{
        category: "pharmacyProducts" | "diagnosticProducts";
        product: IProduct;
      }>
    ) => {

      let message = "";
      if (action.payload.category === "pharmacyProducts") {
        message = CartItemToast["success"]["pharmacy-product"];
      } else {
        message = CartItemToast["success"]["diagnostic-product"];
      }
      const { category, product } = action.payload;
      const existingProductIndex = state[category].findIndex(
        (v) => v._id === product._id
      );
      if (existingProductIndex !== -1) {
        state[category][existingProductIndex] = product;
      } else {
        state[category].push(product);
      }
      toast.success("Successfully added to cart");
    },
    addMultipleItems: (
      state,
      action: PayloadAction<{
        category: "pharmacyProducts" | "diagnosticProducts";
        products: IProduct[];
        toast?: any;
      }>
    ) => {
      const { category, products, toast } = action.payload;
      let addedCount = 0;
      let skippedCount = 0;

      products.forEach((product) => {
        const existingProductIndex = state[category].findIndex(
          (v) => v._id === product._id
        );
        if (existingProductIndex === -1) {
          // Product doesn't exist, add it
          state[category].push(product);
          addedCount++;
        } else {
          // Product already exists, skip it
          skippedCount++;
        }
      });

      // // Show appropriate toast message
      // if (addedCount > 0 && skippedCount > 0) {
      //   toast.success(`${addedCount} new item${addedCount > 1 ? 's' : ''} added to cart, ${skippedCount} item${skippedCount > 1 ? 's' : ''} already in cart`);
      // } else if (addedCount > 0) {
      // } else if (skippedCount > 0) {
      //   toast.success(`All ${skippedCount} item${skippedCount > 1 ? 's' : ''} already in cart`);
      // }
      if (toast) {
        toast.success(
          `${addedCount} item${addedCount > 1 ? "s" : ""} added to cart`
        );
      }
    },
    removeItem: (
      state,
      action: PayloadAction<{
        category: "pharmacyProducts" | "diagnosticProducts";
        productId: string;
      }>
    ) => {
      const { category, productId } = action.payload;
      state[category] = state[category].filter(
        (item) => item?._id !== productId
      );
      toast.success("Successfully removed from cart");
    },
    updateItemQuantity: (
      state,
      action: PayloadAction<{
        category: "pharmacyProducts" | "diagnosticProducts";
        productId: string;
        newQuantity: number;
      }>
    ) => {
      const { category, productId, newQuantity } = action.payload;
      const existingProductIndex = state[category].findIndex(
        (v) => v._id === productId
      );
      if (existingProductIndex !== -1) {
        state[category][existingProductIndex] = {
          _id: productId,
          quantity: newQuantity,
        };
      }
      toast.success("Successfully updated item quantity");
    },
    clearCart: (
      state,
      action: PayloadAction<"pharmacyProducts" | "diagnosticProducts">
    ) => {
      state[action.payload] = [];
    },
    clearSelectedProducts: (
      state,
      action: PayloadAction<{
        category: "pharmacyProducts" | "diagnosticProducts";
        productIds: string[];
      }>
    ) => {
      const { category, productIds } = action.payload;
      state[category] = state[category].filter(
        (item) => !productIds.includes(item._id)
      );
      toast.success("Successfully cleared cart");
    },
  },
});

export const {
  addItem,
  addMultipleItems,
  removeItem,
  updateItemQuantity,
  clearCart,
  setCurrentAddress,
  clearSelectedProducts,
} = cartSlice.actions;

export default cartSlice.reducer;
